'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
require('../GoogleMapsProvider/GoogleMapsProvider.js');
var useGoogleMaps = require('../GoogleMapsProvider/useGoogleMaps.js');
require('../node_modules/ngeohash/main.js');
var MapContext = require('./MapContext.js');
var composePosition = require('./utils/composePosition.js');
var attachEventListeners = require('./utils/attachEventListeners.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _excluded = ["children", "aspectRatio", "styles", "zoom", "center", "disableDoubleClickZoom"];
var VALID_MAP_EVENTS = new Set(['onReady', 'onClick', 'onDragEnd', 'onRecenter', 'onBoundsChanged', 'onCenterChanged', 'onDoubleClick', 'onDragStart', 'onHeadingChanged', 'onIdle', 'onMapTypeIdChanged', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onProjectionChanged', 'onResize', 'onRightClick', 'onTilesLoaded', 'onTiltChanged', 'onZoomChanged']);
var mapListenerProps = [...VALID_MAP_EVENTS].reduce((result, handle) => {
  result[handle] = index.func;
  return result;
}, {});
var useStyles = styles.makeStyles(theme => ({
  root: {
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    height: 0,
    padding: 0,
    paddingBottom: props => "".concat(props.aspectRatio * 100, "%")
  },
  container: {
    position: 'absolute',
    height: '100%',
    width: '100%'
  },
  map: {
    position: 'absolute',
    inset: 0
  }
}));
var MapComponent = _ref => {
  var {
    children,
    aspectRatio = 9 / 16,
    styles,
    // Google Map Props
    zoom = 14,
    center,
    disableDoubleClickZoom = false
  } = _ref,
      listeners = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    aspectRatio
  });
  var {
    status,
    google
  } = useGoogleMaps.useGoogleMaps();
  var mapContainerRef = React__namespace.useRef();
  var [map, setMap] = React__namespace.useState(null); // Initialize map and load into container

  React__namespace.useEffect(() => {
    if (!map && status === 'ready') {
      var composedCenter = composePosition.composePosition({
        position: center,
        google
      });
      var newMap = new google.maps.Map(mapContainerRef.current, {
        zoom,
        center: composedCenter,
        disableDoubleClickZoom
      });
      attachEventListeners.attachEventListeners(_rollupPluginBabelHelpers.objectSpread2({
        target: newMap
      }, listeners));
      setMap(newMap);
    }
  }, [status, google]); // Update the map's center when `center` prop changes.

  React__namespace.useEffect(() => {
    if (map) {
      var composedCenter = composePosition.composePosition({
        position: center,
        google
      });
      map.setCenter(composedCenter);
    }
  }, [map, center]);
  return /*#__PURE__*/React__namespace.createElement(MapContext.MapContext.Provider, {
    value: {
      google,
      map
    }
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.root,
    styles: styles
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React__namespace.createElement("div", {
    ref: mapContainerRef,
    className: classes.map
  }, "Loading...")), children));
};
MapComponent.propTypes = _rollupPluginBabelHelpers.objectSpread2({
  // TODO: add a check for this.

  /** Valid GoogleMapProvider elements. */
  children: index.node,

  /**
   * The decimal value of the aspect ratio of the out map container expressed
   * the as `height / width`.
   */
  aspectRatio: index.number,

  /** Styles applied directly to the container. */
  styles: index.object,
  // Google Map Props
  zoom: index.number,

  /** The center of the map. The map will recenter when this value is changed. */
  center: index.shape({
    lat: index.number,
    lng: index.number
  }).isRequired,

  /** If `true`, the map will not zoom in when double clicked. */
  disableDoubleClickZoom: index.bool
}, mapListenerProps);

exports.MapComponent = MapComponent;
